/*! sg-image-boost.js v1.0.0 | SUNGALLERY 商品画像 表示高速化 (Spotlight 15.x) */
(function () {
  'use strict';
  if (window.__sgImageBoost) return;

  var cfg = {
    productSizes: '',
    productWidths: [246, 493, 600, 713, 823, 990, 1100, 1206, 1346, 1426, 1646, 1946],
    maxViewportPrefetch: 6,
    warmSlides: 2,
    // 拡大モーダルで画像を描画する幅(CSS px)。テーマ既定と同じ 1100 にしてあるので、
    // 元データが足りている画像（2枚目以降）の見え方と拡大率は現状のまま変わらない。
    // 効くのは modalNeverUpscale の方で、元データが足りない 1枚目だけが自動で詰まる。
    // 狭めれば通信量は減るが拡大率も下がる（ギャラリーの表示幅は 337px）。
    //   1100 → DPR2 で 2200px 取得 / ギャラリー比 3.3倍 / 写真1枚 約510KB
    //    742 → DPR2 で 1484px 取得 / ギャラリー比 2.2倍 / 写真1枚 約239KB
    // 0 を指定するとテーマ既定のまま何もしない。
    modalDisplayWidth: 1100,
    // 元データが足りない画像は描画幅を詰めて、引き伸ばしによるボケを抑える。
    modalNeverUpscale: true,
    // 実ピクセルの何倍までなら引き伸ばしを許すか。
    // このストアの画像は多くが 990px なので、1.0 にすると DPR2 では 495px 表示となり
    // 拡大率が物足りなくなる。鮮明さと拡大率のバランスをここで決める。
    //   1.0 → 495px 表示 / 完全に鮮明 / 画面(375px)比 1.3倍
    //   1.5 → 742px 表示 / わずかに甘い / 画面比 2.0倍
    //   2.0 → 990px 表示 / 甘い       / 画面比 2.6倍
    //   2.22→ 1100px 表示 = 導入前と同じ（最もボケる）
    modalMaxUpscale: 1.5,
    // 取得幅の計算に使う DPR の上限。DPR3 端末で無闇に巨大な画像を取らないための蓋。
    modalMaxDpr: 2,
    // 拡大画像に何を使うか。
    //   'gallery' ギャラリーが既に読み込んだ画像をそのまま使う（既定）。
    //             追加通信ゼロ・即時表示。拡大しない人には一切の余分な通信が発生しない。
    //             拡大率は元の画素数で決まる（modalMaxUpscale で調整）。
    //   'hires'   モーダル用に高解像度を別途取得する。拡大率は上げられるが通信が増え、
    //             先読みしても回線が細いと待たされる。
    modalSource: 'gallery',
    // 拡大画像の先読みのきっかけ。modalSource:'gallery' では不要（既に読み込み済みのため）。
    //   'intent' 写真に触れた/ホバーした/スワイプした/見て手が止まった人にだけ先読みする（既定）
    //   'load'   ページ読み込み後すぐ。拡大しない人にも通信が発生する
    //   false    先読みしない
    // いずれも load 後・fetchpriority=low で走るので、ページ本体の読み込みとは競合しない。
    // Save-Data / 2G の端末では設定に関わらず無効。
    warmModal: 'intent',
    // 'intent' に「写真が画面に入ったまま滞留した」を加える場合の時間(ms)。0 で無効（既定）。
    // ギャラリーはファーストビューにあるため、これを有効にすると
    // 商品ページを開いただけの人にも先読みが走る＝実質全員が対象になる。
    // 既定では、写真に触れた/ホバーした/スワイプした人だけを対象にする。
    warmModalDwell: 0,
    debug: false
  };
  var userCfg = window.SG_IMAGE_BOOST || {};
  for (var k in userCfg) if (Object.prototype.hasOwnProperty.call(userCfg, k)) cfg[k] = userCfg[k];
  cfg.productWidths = cfg.productWidths.map(Number);
  cfg.debug = !!cfg.debug || /[?&]sgdebug=1/.test(location.search);

  var state = { version: '1.1.0', warmed: [], warmedModal: [], modalTuned: 0, lcpBoosted: null, preloadMatch: null };
  window.__sgImageBoost = state;

  function log() {
    if (!cfg.debug || !window.console) return;
    console.log.apply(console, ['[sg-image-boost]'].concat([].slice.call(arguments)));
  }

  var conn = navigator.connection || {};
  var reducedData = !!conn.saveData ||
    (window.matchMedia && matchMedia('(prefers-reduced-data: reduce)').matches) ||
    /(^|-)2g$/.test(conn.effectiveType || '');
  var hoverCapable = window.matchMedia && matchMedia('(hover: hover)').matches;
  var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 200); };

  var CDN_BASE_RE = /^((?:https?:)?\/\/[^/]+\/cdn\/shop\/(?:files|products)\/[^?#]+\?v=\d+)/;
  function cdnBase(url) {
    var m = CDN_BASE_RE.exec(url || '');
    return m ? m[1] : null;
  }

  // ---------- 商品ページ: LCP 画像 ----------
  function firstSlideImg(root) {
    if (root) return root.querySelector('.product__media-item img, .product__media img');
    var slides = gallerySlides();
    return (slides[0] && slides[0].querySelector('img')) || document.querySelector('.product__media img');
  }

  function productSizes() {
    var img = firstSlideImg();
    return (img && img.getAttribute('sizes')) || cfg.productSizes;
  }

  function boostLcp(root) {
    var img = firstSlideImg(root);
    if (!img || img === state.lcpBoosted) return;
    if (img.getAttribute('fetchpriority') !== 'high') img.setAttribute('fetchpriority', 'high');
    if (img.loading === 'lazy') img.loading = 'eager';
    state.lcpBoosted = img;

    // LCP 画像が読み終わったら、snippet が保留している lazy 画像を解放する
    var hold = window.__sgHold;
    if (hold) {
      if (img.complete) hold.release();
      else {
        img.addEventListener('load', hold.release, { once: true });
        img.addEventListener('error', hold.release, { once: true });
      }
    }

    var pre = document.querySelector('link[rel="preload"][data-sg-lcp]');
    if (pre) {
      var sizesMatch = (pre.getAttribute('imagesizes') || '') === (img.getAttribute('sizes') || '');
      var srcsetMatch = normalizeSrcset(pre.getAttribute('imagesrcset')) === normalizeSrcset(img.getAttribute('srcset'));
      state.preloadMatch = sizesMatch && srcsetMatch;
      if (!state.preloadMatch && window.console) {
        console.warn('[sg-image-boost] preload と LCP 画像の srcset/sizes が一致しません。' +
          ' snippets/sg-image-boost.liquid の sg_media_width / widths をテーマ設定に合わせてください。',
          { sizesMatch: sizesMatch, srcsetMatch: srcsetMatch });
      }
      log('preload match:', state.preloadMatch);
    }
  }

  function normalizeSrcset(s) {
    return (s || '').split(',').map(function (c) {
      var p = c.trim().split(/\s+/);
      return (p[0] || '').replace(/^https?:/, '') + ' ' + (p[1] || '');
    }).join(',');
  }

  function warmNextSlides() {
    if (reducedData) return;
    if (window.__sgHold) window.__sgHold.release();
    var slides = gallerySlides();
    for (var i = 1; i < slides.length && i <= cfg.warmSlides; i++) {
      var img = slides[i].querySelector('img');
      if (img && img.loading === 'lazy') {
        img.loading = 'eager';
        try { img.fetchPriority = 'low'; } catch (e) {}
        log('warm slide', i + 1);
      }
    }
  }

  // ---------- 拡大モーダル ----------
  // モーダル画像はすべて loading=lazy で、モーダルを開くまで一度も取得されない。
  // よって srcset を書き換えても二重ダウンロードにならない（LCP 画像と違いテーマ編集が不要）。
  function modalRoot() { return document.querySelector('product-modal, .product-media-modal'); }
  function modalImages() {
    var m = modalRoot();
    return m ? m.querySelectorAll('img') : [];
  }

  // モーダルの中にも .product__media-item が入る作りなので、ギャラリー側の探索は
  // media-gallery の中に限定する。限定しないとモーダル画像自身をギャラリー画像と
  // 取り違えて、対応付けが崩れる。
  function gallerySlides() {
    var root = document.querySelector('media-gallery');
    if (root) return root.querySelectorAll('.product__media-item');
    var m = modalRoot();
    var all = document.querySelectorAll('.product__media-item'), out = [];
    for (var i = 0; i < all.length; i++) if (!m || !m.contains(all[i])) out.push(all[i]);
    return out;
  }

  // 保留中は srcset が data-sg-ss に退避されているので、どちらに入っていても扱う
  function srcsetAttr(img) { return img.hasAttribute('data-sg-ss') ? 'data-sg-ss' : 'srcset'; }
  function srcAttr(img) { return img.hasAttribute('data-sg-sc') ? 'data-sg-sc' : 'src'; }

  // ギャラリー画像がまだ読み込まれていない場合、currentSrc は空になる。
  // その場合はブラウザと同じ規則（必要幅以上で最小の候補、無ければ最大）で srcset から選ぶ。
  function pickFromSrcset(img) {
    var ss = img.getAttribute(srcsetAttr(img)) || '';
    var cands = [];
    ss.split(',').forEach(function (c) {
      var p = c.trim().split(/\s+/);
      var w = Number((/^(\d+)w$/.exec(p[1] || '') || [])[1]);
      if (p[0] && w) cands.push({ u: p[0], w: w });
    });
    if (!cands.length) return null;
    cands.sort(function (a, b) { return a.w - b.w; });
    var slot = img.getBoundingClientRect().width || img.offsetWidth || 0;
    var need = slot * (window.devicePixelRatio || 1);
    var chosen = null;
    for (var i = 0; i < cands.length; i++) if (cands[i].w >= need) { chosen = cands[i]; break; }
    return (chosen || cands[cands.length - 1]).u;
  }

  function galleryUrl(img) {
    return img.currentSrc || pickFromSrcset(img) || img.getAttribute(srcAttr(img)) || null;
  }

  function withWidth(url, w) {
    return /[?&]width=\d+/.test(url)
      ? url.replace(/([?&])width=\d+/, '$1width=' + w)
      : url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  var modalDpr = Math.min(window.devicePixelRatio || 1, cfg.modalMaxDpr || 2);
  function modalFetchWidth() { return Math.round(cfg.modalDisplayWidth * modalDpr); }

  // <img> 要素の naturalWidth は、元の srcset の w 記述子から算出された密度が要素に残るため
  // srcset を外した後も補正され続ける（990px の画像が 1100 と報告される）。
  // 素の Image() には密度が付かないので、実ピクセル数はそちらで測る。
  // URL は既にモーダル側が取得済み or 先読み済みなのでキャッシュヒットし、追加通信は発生しない。
  var trueWidth = Object.create(null);
  function measureTrue(url, cb) {
    if (!url) return;
    if (trueWidth[url]) return cb(trueWidth[url]);
    var p = new Image();
    p.onload = function () { trueWidth[url] = p.naturalWidth; cb(p.naturalWidth); };
    p.onerror = function () { cb(0); };
    p.src = url;
  }

  // 描画幅を固定するので、レスポンシブ選択は不要。srcset を外して 1 本の URL に絞る。
  // こうすると naturalWidth が w 記述子による密度補正を受けず、実ピクセル数を素直に返すため、
  // 「元データが足りない画像だけ描画幅を詰める」判定が正しくできる。
  //
  // modalSource: 'gallery' の場合は、対応するギャラリー画像が「実際に読み込んだ URL」を
  // そのまま使う。既にキャッシュにあるので拡大表示は追加通信ゼロ・即時になる。
  // 先読みも不要になるため、拡大しない人には一切の余分な通信が発生しない。
  function tuneModalImage(img, galleryImg) {
    var sa = srcsetAttr(img), ca = srcAttr(img);
    var ref = img.getAttribute(ca) || (img.getAttribute(sa) || '').split(',')[0].trim().split(/\s+/)[0];
    if (!ref) return false;
    var url = (cfg.modalSource === 'gallery' && galleryImg && galleryUrl(galleryImg))
      || withWidth(ref, modalFetchWidth());
    img.removeAttribute(sa);
    img.removeAttribute('sizes');
    img.setAttribute(ca, url);
    // テーマは意図的に max-width:none にしている（画面より大きく描画して指でパンさせるため）。
    // ここで 100% を入れると画像が画面幅に収まり、拡大表示そのものが成立しなくなる。
    img.style.maxWidth = 'none';
    img.style.height = 'auto';
    img.style.width = displayWidthFor(url) + 'px';
    // 実際に届いた画素数が要求より少なければ（＝元データがそこまで無い）描画幅を詰める
    if (cfg.modalNeverUpscale) {
      var fit = function () {
        measureTrue(url, function (real) {
          if (real) img.style.width = displayWidthFor(url) + 'px';
        });
      };
      if (img.complete) fit();
      else img.addEventListener('load', fit, { once: true });
    }
    return true;
  }

  // 実ピクセル数が分かっていれば、許容した引き伸ばし率を超えない幅を返す
  function displayWidthFor(url) {
    var W = cfg.modalDisplayWidth;
    if (!cfg.modalNeverUpscale) return W;
    var real = trueWidth[url];
    if (!real) return W;
    return Math.min(W, Math.floor(real * (cfg.modalMaxUpscale || 1) / modalDpr));
  }

  function tuneModal() {
    if (!cfg.modalDisplayWidth) return;
    // ギャラリー画像とモーダル画像を data-media-id で対応付ける
    var gallery = Object.create(null);
    var slides = gallerySlides();
    for (var s = 0; s < slides.length; s++) {
      var t = slides[s].querySelector('[data-media-id]');
      var gi = slides[s].querySelector('img');
      if (t && gi) gallery[t.getAttribute('data-media-id')] = gi;
    }
    var imgs = modalImages(), n = 0;
    for (var i = 0; i < imgs.length; i++) {
      if (imgs[i].__sgTuned) continue;
      var id = imgs[i].getAttribute('data-media-id');
      var g = id ? gallery[id] : null;
      // ギャラリー画像が読み込まれれば currentSrc が確定するので、確定後にもう一度合わせる
      if (cfg.modalSource === 'gallery' && g && !g.currentSrc && !g.__sgRetry) {
        g.__sgRetry = 1;
        g.addEventListener('load', function () {
          var t = modalImages();
          for (var k = 0; k < t.length; k++) t[k].__sgTuned = 0;
          tuneModal();
        }, { once: true });
      }
      imgs[i].__sgTuned = 1;
      if (tuneModalImage(imgs[i], g)) n++;
    }
    if (n) {
      state.modalTuned += n;
      log('modal tuned', n, cfg.modalSource === 'gallery' ? '→ ギャラリー画像を再利用（追加通信なし）' : '→ 取得 ' + modalFetchWidth() + 'px');
    }
  }

  // requestIdleCallback は非表示タブでは発火しないため、ユーザー操作に反応する先読みを
  // idle だけに任せると動かない。表示中であることを確認したうえで、idle とタイムアウトの
  // 早い方で実行する（非表示タブでは実行しない＝バックグラウンドで通信を使わない）。
  function whenVisible(fn) {
    if (document.visibilityState === 'visible') return fn();
    var h = function () {
      if (document.visibilityState !== 'visible') return;
      document.removeEventListener('visibilitychange', h);
      fn();
    };
    document.addEventListener('visibilitychange', h);
  }
  function soon(fn, ms) {
    var done = false;
    var run = function () { if (done) return; done = true; fn(); };
    idle(run);
    setTimeout(run, ms || 1500);
  }
  function warmModalSoon() { whenVisible(function () { soon(warmCurrentModal); }); }

  // ギャラリーのスライドと拡大画像は data-media-id で 1 対 1 に対応する。
  // 並び順に依存すると、動画やバリエーション切り替えでズレるため id で引く。
  function modalImageFor(slide) {
    if (!slide) return null;
    var toggle = slide.querySelector('[data-media-id]');
    var id = toggle && toggle.getAttribute('data-media-id');
    if (!id) return null;
    var m = document.querySelector('product-modal, .product-media-modal');
    return m ? m.querySelector('img[data-media-id="' + id + '"]') : null;
  }

  // 今表示しているスライドに対応する拡大画像だけを先読みする（全部やると数 MB になる）
  var warmedModal = Object.create(null);
  var modalKeep = [];
  function warmCurrentModal() {
    // ギャラリー画像を再利用する構成では、拡大画像は既にキャッシュにあるので先読みは無意味
    if (cfg.modalSource === 'gallery') return;
    if (!cfg.warmModal || reducedData) return;
    tuneModal();
    var slides = gallerySlides();
    var active = null;
    for (var s = 0; s < slides.length; s++) if (slides[s].classList.contains('is-active')) { active = slides[s]; break; }
    active = active || slides[0];
    var img = modalImageFor(active);
    if (!img) return;
    // tuneModal 済みなので src は 1 本の URL。モーダルが開いた時と同じ URL を取りに行く
    var url = img.getAttribute(srcAttr(img));
    if (!url || warmedModal[url]) return;
    warmedModal[url] = 1;
    var w = new Image();
    try { w.fetchPriority = 'low'; } catch (e) {}
    w.decoding = 'async';
    w.src = url;
    modalKeep.push(w);
    w.onload = w.onerror = function () {
      var i = modalKeep.indexOf(w);
      if (i > -1) modalKeep.splice(i, 1);
      // 先読み用の Image は密度が付かないので、ここで測った値が実ピクセル数の正解になる
      if (w.naturalWidth) {
        trueWidth[url] = w.naturalWidth;
        img.style.width = displayWidthFor(url) + 'px';
      }
      state.warmedModal.push(w.currentSrc);
      log('modal warmed', w.currentSrc, w.naturalWidth + 'px → 描画', displayWidthFor(url) + 'px');
    };
  }

  // 先読みのきっかけ: 写真に触れた/ホバーした/スワイプした人だけ。
  // 商品説明を読んで離脱するだけの人には、拡大画像の通信を一切発生させない。
  function bindGalleryIntent() {
    if (cfg.modalSource === 'gallery') return;
    if (cfg.warmModal !== 'intent' || reducedData) return;
    var gallery = document.querySelector('media-gallery') || document.querySelector('.product__media-list');
    if (!gallery || gallery.__sgWarmBound) return;
    gallery.__sgWarmBound = 1;
    var fire = function () { warmModalSoon(); };
    if (hoverCapable) gallery.addEventListener('pointerenter', fire, { passive: true });
    gallery.addEventListener('touchstart', fire, { passive: true });
    gallery.addEventListener('pointerdown', fire, { passive: true });
    gallery.addEventListener('focusin', fire, { passive: true });
    // スワイプ（他の写真を見に行く動作）も、写真への関与とみなす
    var list = gallery.querySelector('.product__media-list') || gallery;
    list.addEventListener('scroll', function () {
      clearTimeout(list.__sgIntentT);
      list.__sgIntentT = setTimeout(fire, 150);
    }, { passive: true });

    // 任意: 「写真が画面に入ったまま滞留した」も intent に含める（既定は無効）
    if (cfg.warmModalDwell > 0 && 'IntersectionObserver' in window) {
      var timer = null;
      new IntersectionObserver(function (entries) {
        var seen = entries[0] && entries[0].isIntersecting;
        if (seen && !timer) timer = setTimeout(function () { timer = null; fire(); }, cfg.warmModalDwell);
        else if (!seen && timer) { clearTimeout(timer); timer = null; }
      }, { threshold: 0.5 }).observe(gallery);
    }
    log('gallery intent bound');
  }

  // ---------- 商品カード → 遷移先 LCP 画像の先読み ----------
  var warmedBases = Object.create(null);
  var keepAlive = [];
  var viewportWarmCount = 0;

  function productSrcset(base) {
    return cfg.productWidths.map(function (w) { return base + '&width=' + w + ' ' + w + 'w'; }).join(', ');
  }

  function warmProductImage(base, reason) {
    if (!base || warmedBases[base]) return;
    var sizes = productSizes();
    if (!sizes) return;
    warmedBases[base] = 1;
    var img = new Image();
    try { img.fetchPriority = 'low'; } catch (e) {}
    img.decoding = 'async';
    img.sizes = sizes;
    img.srcset = productSrcset(base);
    img.src = base + '&width=' + cfg.productWidths[3];
    keepAlive.push(img);
    img.onload = img.onerror = function () {
      var i = keepAlive.indexOf(img);
      if (i > -1) keepAlive.splice(i, 1);
      state.warmed.push({ url: img.currentSrc, reason: reason });
      log('warmed (' + reason + ')', img.currentSrc);
    };
  }

  function cardOf(node) {
    return node.closest ? node.closest('.card-wrapper, .card, product-card, .product-card') : null;
  }

  function cardTarget(card) {
    var a = card.querySelector('a[href*="/products/"]');
    var img = card.querySelector('.card__media img, img');
    if (!a || !img) return null;
    var path = a.pathname || '';
    if (path === location.pathname) return null;
    var base = cdnBase(img.currentSrc || img.src || (img.getAttribute('srcset') || '').split(/\s/)[0]);
    return base ? { base: base, href: path } : null;
  }

  var viewportObserver = null;
  function bindCards() {
    if (reducedData) return;
    var cards = document.querySelectorAll('.card-wrapper');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.__sgBound) continue;
      if (!card.querySelector('a[href*="/products/"]')) continue;
      card.__sgBound = 1;
      var onIntent = (function (c) {
        return function () {
          var t = cardTarget(c);
          if (t) warmProductImage(t.base, 'intent');
        };
      })(card);
      if (hoverCapable) card.addEventListener('pointerenter', onIntent, { passive: true });
      card.addEventListener('touchstart', onIntent, { passive: true });
      card.addEventListener('focusin', onIntent, { passive: true });
      if (!hoverCapable && viewportObserver) viewportObserver.observe(card);
    }
  }

  function setupViewportWarm() {
    if (hoverCapable || reducedData || !('IntersectionObserver' in window)) return;
    viewportObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        viewportObserver.unobserve(e.target);
        if (viewportWarmCount >= cfg.maxViewportPrefetch) return;
        var t = cardTarget(e.target);
        if (!t) return;
        viewportWarmCount++;
        idle(function () { warmProductImage(t.base, 'viewport'); });
      });
    }, { threshold: 0.5 });
  }

  // ---------- 初期化 ----------
  var bindScheduled = false;
  function scheduleBind() {
    if (bindScheduled) return;
    bindScheduled = true;
    requestAnimationFrame(function () { bindScheduled = false; bindCards(); boostLcp(); });
  }

  function onReady() {
    boostLcp();
    setupViewportWarm();
    bindCards();
    // 取得前に効かせる必要があるので、モーダルを開く前に済ませておく
    tuneModal();
    bindGalleryIntent();
    // 拡大ボタンが押された瞬間に全枚数を取り直す。capture 段階で走るので、
    // テーマがモーダルを開いて lazy 画像の取得が始まるより先に URL を確定できる。
    // ギャラリー画像は遅延読み込みで後から currentSrc が変わることがあるため、
    // 一度合わせて終わりにせず、開く直前の実際の値で必ず同期し直す。
    document.addEventListener('click', function (e) {
      if (!e.target.closest || !e.target.closest('.product__media-toggle, .product__modal-opener')) return;
      var t = modalImages();
      for (var k = 0; k < t.length; k++) t[k].__sgTuned = 0;
      tuneModal();
    }, true);

    if (document.querySelector('.product__media-item')) {
      var afterLoad = function () {
        idle(function () { warmNextSlides(); tuneModal(); bindGalleryIntent(); });
        // 'load' 指定の時だけ、触っていない人にも先読みする
        if (cfg.warmModal === 'load') warmModalSoon();
      };
      if (document.readyState === 'complete') afterLoad();
      else window.addEventListener('load', afterLoad, { once: true });

      // スライドを切り替えたら、その拡大版を先読みし直す
      var onSlide = warmModalSoon;
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.slider-button, .thumbnail, .product__media-list')) onSlide();
      }, { passive: true });
      var list = document.getElementById('Slider-Gallery-' + (document.querySelector('media-gallery')?.id || '').replace('MediaGallery-', ''))
        || document.querySelector('.product__media-list');
      if (list) list.addEventListener('scroll', function () {
        clearTimeout(list.__sgT);
        list.__sgT = setTimeout(onSlide, 250);
      }, { passive: true });
    }

    if ('MutationObserver' in window) {
      new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          if (muts[i].addedNodes.length) { scheduleBind(); return; }
        }
      }).observe(document.body, { childList: true, subtree: true });
    }
    log('ready', {
      hoverCapable: hoverCapable, reducedData: reducedData,
      held: window.__sgHold ? window.__sgHold.count() : 0,
      modalTuned: state.modalTuned, modalDisplay: cfg.modalDisplayWidth, modalFetch: modalFetchWidth(),
      warmModal: cfg.warmModal, sizes: productSizes()
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', onReady, { once: true });
  else onReady();
})();
